export default {
  'leaderboardActivity.saving': 'Saving...',
  'leaderboardActivity.operationSuccess': 'Operation successful',
  'leaderboardActivity.search': 'Search',
  'leaderboardActivity.reset': 'Reset',
  'leaderboardActivity.totalRecords': '{{total}} records in total',

  'leaderboardActivity.listTitle': 'Leaderboard Activity List',
  'leaderboardActivity.addActivity': 'Add Activity',
  'leaderboardActivity.colName': 'Activity Name',
  'leaderboardActivity.colShowTime': 'Show Time',
  'leaderboardActivity.colEnableTime': 'Effective Time',
  'leaderboardActivity.colSettle': 'Settlement',
  'leaderboardActivity.colStatus': 'Status',
  'leaderboardActivity.colCreateTime': 'Create Time',
  'leaderboardActivity.colUpdateTime': 'Update Time',
  'leaderboardActivity.colOperator': 'Operator',
  'leaderboardActivity.colOperation': 'Action',
  'leaderboardActivity.edit': 'Edit',
  'leaderboardActivity.copy': 'Copy',
  'leaderboardActivity.enable': 'Enable',
  'leaderboardActivity.disable': 'Disable',
  'leaderboardActivity.confirmDisable': 'Disable this activity?',
  'leaderboardActivity.confirmEnable': 'Enable this activity?',
  'leaderboardActivity.statusNotStarted': 'Not Started',
  'leaderboardActivity.statusRunning': 'Running',
  'leaderboardActivity.statusEnded': 'Ended',
  'leaderboardActivity.statusDisabled': 'Disabled',
  'leaderboardActivity.settleDaily': 'Daily',
  'leaderboardActivity.settleEveryNDays': 'Every {{n}} days',

  'leaderboardActivity.addTitle': 'Add Leaderboard Activity',
  'leaderboardActivity.editTitle': 'Edit Leaderboard Activity',
  'leaderboardActivity.save': 'Save',
  'leaderboardActivity.back': 'Back',
  'leaderboardActivity.basicSettings': 'Activity Basics',
  'leaderboardActivity.nameZh': 'Activity Name (ZH)',
  'leaderboardActivity.enterNameZh': 'Enter activity name (ZH)',
  'leaderboardActivity.nameEn': 'Activity Name (EN)',
  'leaderboardActivity.enterNameEn': 'Enter activity name (EN)',
  'leaderboardActivity.currency': 'Currency',
  'leaderboardActivity.selectCurrency': 'Select currency',
  'leaderboardActivity.showTime': 'Show Time',
  'leaderboardActivity.selectShowTime': 'Select show time',
  'leaderboardActivity.enableTime': 'Effective Time',
  'leaderboardActivity.selectEnableTime': 'Select effective time',

  'leaderboardActivity.boardRecordsTitle': 'Settlement Results',
  'leaderboardActivity.all': 'All',
  'leaderboardActivity.export': 'Export',
  'leaderboardActivity.operationFail': 'Operation failed',
  'leaderboardActivity.colActivity': 'Activity',
  'leaderboardActivity.colBoard': 'Board',
  'leaderboardActivity.colBoardName': 'Board Name',
  'leaderboardActivity.colPeriod': 'Period',
  'leaderboardActivity.colRank': 'Rank',
  'leaderboardActivity.colUserAccount': 'Member Account',
  'leaderboardActivity.colMetricValue': 'Metric Value',
  'leaderboardActivity.colSnapshotTime': 'Snapshot Time',
  'leaderboardActivity.filterActivityDate': 'Activity Date',
  'leaderboardActivity.colVip': 'VIP Level',
  'leaderboardActivity.selectVip': 'Select VIP level',
  'leaderboardActivity.colCoin': 'Currency',
  'leaderboardActivity.colSettleDate': 'Settle Date',
  'leaderboardActivity.colYesterdayBet': 'Yesterday Valid Bet',
  'leaderboardActivity.colTodayBet': 'Today Valid Bet',
  'leaderboardActivity.colActivityTotalBet': 'Total Valid Bet in Activity',
  'leaderboardActivity.summaryTitle': 'Total Valid Bet',
  'leaderboardActivity.summaryNote':
    'All enabled activities　Each member counted once　Unranked members excluded　Not affected by filters or paging',
  'leaderboardActivity.summaryMemberCount': '{{count}} ranked members (deduplicated)',
  'leaderboardActivity.summaryLoading': 'Calculating, please wait',
  'leaderboardActivity.summaryLoadFail': 'Failed to load data, please retry',
  'leaderboardActivity.summaryEmpty': 'No data. Enabled activities have not produced any ranking records yet.',
  'leaderboardActivity.summaryRetry': 'Retry',
  'leaderboardActivity.colBetCount': 'Bet Count',
  'leaderboardActivity.colProfitRate': 'Profit Rate',
  'leaderboardActivity.colLastBetTime': 'Last Bet Time',
  'leaderboardActivity.colRewardDue': 'Reward Due',
  'leaderboardActivity.colAwardStatus': 'Grant Status',
  'leaderboardActivity.rewardTypeCash': 'Cash',
  'leaderboardActivity.rewardTypePoint': 'Points',
  'leaderboardActivity.rewardTypeSpin': 'Spin Ticket',
  'leaderboardActivity.awardPendingConfirm': 'Pending Confirm',
  'leaderboardActivity.awardPendingGrant': 'Pending Grant',
  'leaderboardActivity.awardGranted': 'Granted',
  'leaderboardActivity.awardRejected': 'Rejected',
  'leaderboardActivity.actionConfirm': 'Confirm Grant',
  'leaderboardActivity.actionReject': 'Reject',
  'leaderboardActivity.batchConfirm': 'Batch Confirm Grant',
  'leaderboardActivity.confirmGrantTip': 'Confirm grant for selected records? They will move to Pending Grant and be paid by the 16:00 batch.',
  'leaderboardActivity.rejectTip': 'Reject selected records? They will not be granted.',
  'leaderboardActivity.noSelection': 'Please select records first',
  'leaderboardActivity.grantSuccess': 'Success, {{n}} record(s)',

  'leaderboardActivity.awardRecordsTitle': 'Award Records',
  'leaderboardActivity.colRewardType': 'Reward Type',
  'leaderboardActivity.colRewardValue': 'Reward Value',
  'leaderboardActivity.colGrantStatus': 'Grant Status',
  'leaderboardActivity.colGrantTime': 'Grant Time',
  'leaderboardActivity.grantPending': 'Pending',
  'leaderboardActivity.grantGranted': 'Granted',
  'leaderboardActivity.grantFailed': 'Failed',
  'leaderboardActivity.colRejectReason': 'Reject Reason',
};
